import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export const defaults = Object.freeze({
  primary: '#6C7FEE',
  primary_inverse: '#FFFFFF',
  secondary: '#6E7FF1',
  success: '#8DDC88',
  info: '#71BAFF',
  danger: '#F8706D',
  warning: '#ffcc66',
  warning_inverse: '#000',
  accent: '#82B1FF',
  error: '#FF5252',
  itemLabel: '#525f7f',
  mainTitleLabel: '#32325d',
  whatsappGrey: '#EDEDED',
  messageBackground: '#f2f2f2',
  managerColor: '#2196F3',
  managerColor_inverse: '#FFFFFF',
  backgroundColor: 'C5F2F9',
  lightblue: '5EA5BC',
  deepblue: '005084',
  drawerHover: '74DEF9',
  textColor: '#3C89F1',
  borderColor: '#3C89F1',
  bttomBarColor: '#60D0AD',
  topBarColor: '#54BAE7',
  searchColor: '#048BF9',
  twoColumnBackgroundColor: '#A8DCFF',
  filterButtonColor: '#E1E1E1',
  buttonDeepBlue: '#008CF9',
  buttonLightBlue: '#3BC3FC',
  /*   anchor:'74DEF9' */
});

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: { ...defaults },
    },
  },
});
